/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const School = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4" }],
    [
      "path",
      {
        d: "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10"
      }
    ],
    ["path", { d: "M18 5v17" }],
    ["path", { d: "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6" }],
    ["path", { d: "M6 5v17" }],
    ["circle", { cx: "12", cy: "9", r: "2" }]
  ]
];

export { School as default };
//# sourceMappingURL=school.js.map
